import { useContext } from "react";

import classes from "./CartActions.module.css";

import CustomButton from "../../General_Elements/CustomButton/CustomButton";

import ShelfContext from "../../../store/shelf-context";
import CartContext from "../../../store/cart-context";

// component for buttons at bottom of cart
const CartActions = (props) => {
  const shelfCtx = useContext(ShelfContext);
  const cartCtx = useContext(CartContext);

  const numBooks = shelfCtx.books.length;
  const numCartDrinks = cartCtx.items.length;
  const validNumBooks = numBooks < 15; // ensure number of books in shelf is under max
  const validCartCocktails = numCartDrinks > 0 && numCartDrinks < 1000; // no more than 1000 drinks in cart
  const validForm = validNumBooks && validCartCocktails;

  return (
    <div className={classes.buttons}>
      <button onClick={props.onClose} className={classes.close_button}>
        CLOSE
      </button>
      <button
        className={classes.create_report_button}
        onClick={props.toggleShowForm}
        disabled={!validForm}
      >
        CREATE
      </button>
    </div>
  );
};

export default CartActions;
